import gql from 'graphql-tag';

export default gql`
    mutation CreateLoads($input: CreateLoadsInput) {
        createLoads(input: $input) {
            errors
            loadIds
        }
    }
`;
